/** 에디터 지원 로케일. 백엔드 AdminSetBodyDto enum(ko/en/ja)과 1:1. */
export type BlipLocale = "ko" | "en" | "ja";

/** 로케일별 본문 HTML 묶음. 빈 로케일은 생략(서버 read no-op, non-breaking). */
export type BlipI18nHtml = Partial<Record<BlipLocale, string>>;

export const BLIP_LOCALES: readonly BlipLocale[] = ["ko", "en", "ja"] as const;

/** 토큰 카탈로그 항목. key=서버 치환 키(예: "아티스트홈명"), label=툴바 표기. */
export interface BlipTokenDef {
  key: string;
  label: string;
}

/**
 * 펀딩 안내/가이드 기본 토큰.
 * 서버 vote.service applyTabTokens 치환 키와 1:1 — `{@${key}}` 텍스트로 직렬화됨.
 */
export const FUNDING_TOKENS: readonly BlipTokenDef[] = [
  { key: "아티스트홈명", label: "아티스트 홈명" },
  { key: "팬덤명", label: "팬덤명" },
  { key: "스케줄명", label: "스케줄명" },
  { key: "펀딩종료일시", label: "펀딩 종료일시" },
  { key: "펀딩종료일시+5", label: "펀딩 종료일시+5" },
] as const;
